"use client";

import { useMemo } from "react";
import { rewriteAssetUrlsInHtml } from "@/app/[lang]/utils/asset-cdn";

/**
 * Prepares Strapi HTML for rendering: every S3 asset URL - images (`src`) and
 * PDF links (`href`) alike - is mapped to CloudFront. Pure string replace, no
 * round-trip, no flash, so the first paint is already correct.
 */
export const useRewrittenHtml = (html: string): string =>
    useMemo(() => rewriteAssetUrlsInHtml(html), [html]);
